import DrawingMode from "../../Components/Drawing/Mode";
import Type from "../Type";


const initDrawingState = {
    showTool: false,
    drawingMode: DrawingMode.STOP,
    modeChosen: 'nangcao',
    evtPath: null,
    listPoints: [],
    listLine: [],
    textInput: null,
    textInputLoGioi: null,
    keyActive: ''
}

const Drawing = (state = initDrawingState, { type, evt }) => {
    switch (type) {

        case Type.SHOW_ON_DRAWING: return { ...state, showTool: true };
        case Type.SHOW_KEY_ACTIVE: return { ...state, keyActive: evt };
        case Type.SHOW_OFF_DRAWING: return initDrawingState;
        case Type.STOP_DRAWING: return { ...state, drawingMode: DrawingMode.STOP };
        case Type.START_DRAWING: return { ...state, drawingMode: evt };
        case Type.SET_MODE_DRAWING: {

            return { ...state, modeChosen: evt };
        }
        case Type.SET_DRAWING_TEXT_INPUT: return { ...state, textInput: evt };
        case Type.SET_DRAWING_TEXT_INPUT_LOGIOI: return { ...state, textInputLoGioi: evt };
        case Type.CLEAR_PATH_DRAWING: {
            if (state.evtPath)
                state.evtPath.setMap(null);
            return { ...state, evtPath: null };
        }
        case Type.SET_EVT_DRAWING: return { ...state, evtPath: evt }
        case Type.SET_DRAWING_POINT: {

            return { ...state, listPoints: evt }
        }
        case Type.SET_DRAWING_LINE: {

            return { ...state, listLine: evt }
        }
        default: return state;
    }

}

export default Drawing
